export const SET_APPLICATION_DETAIL = 'SET_APPLICATION_DETAIL';
export const CLEAR_APPLICATION_DETAIL = 'CLEAR_APPLICATION_DETAIL';
export const UPDATE_IP_CONFIG = 'UPDATE_IP_CONFIG';
export const UPDATE_IP_PRE_AUTH_VIEW_CONFIG = 'UPDATE_IP_PRE_AUTH_VIEW_CONFIG';
export const UPDATE_IP_CLAIM_VIEW_CONFIG = 'UPDATE_IP_CLAIM_VIEW_CONFIG';
export const UPDATE_RECONCILIATION_IP_CONFIG = 'UPDATE_RECONCILIATION_IP_CONFIG';
export const UPDATE_CLAIMS_DISPLAY_CONFIG = 'UPDATE_CLAIMS_DISPLAY_CONFIG';
export const SET_HIP_ID = 'SET_HIP_ID';
export const SET_IS_HIS_SEARCH_ENABLED = 'SET_IS_HIS_SEARCH_ENABLED';
export const UPDATE_GRIEVANCE_CONFIG = 'UPDATE_GRIEVANCE_CONFIG';
export const UPDATE_REPORTING_CONFIG = 'UPDATE_REPORTING_CONFIG';
export const UPDATE_TAT_REPORTING_CONFIG = 'UPDATE_TAT_REPORTING_CONFIG';
